import { isLocalHttpHost } from "@/core/host";

import { cookieName } from "../i18n.config";
import { BCP47LangCode } from "../i18n.types";

export function replacePathLocale(
  pathname: string,
  currentLang: BCP47LangCode,
  newLang: BCP47LangCode,
): string {
  return pathname.replace(new RegExp(`^/${escapeRegExp(currentLang)}(?=/|$)`), `/${newLang}`);
}

export function isEmbeddedBrowsingContext(): boolean {
  if (typeof window === "undefined") {
    return false;
  }

  try {
    return window.parent !== window;
  } catch {
    return true;
  }
}

export function persistLanguagePreferenceCookie(
  lang: BCP47LangCode,
  options?: { isEmbedded?: boolean },
): void {
  const isEmbedded = options?.isEmbedded ?? isEmbeddedBrowsingContext();
  const isLocalHttpDevelopment =
    window.location.protocol === "http:" && isLocalHttpHost(window.location.hostname);
  const canUsePartitionedEmbedCookie =
    isEmbedded && window.location.protocol === "https:" && !isLocalHttpDevelopment;

  if (canUsePartitionedEmbedCookie) {
    document.cookie = `${cookieName}=${lang};path=/;max-age=31536000;secure;samesite=none;partitioned`;
    return;
  }

  document.cookie = `${cookieName}=${lang};path=/;max-age=31536000;samesite=lax`;
}

function escapeRegExp(value: string): string {
  return value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}

export function readCurrentSearchParams(): URLSearchParams {
  return new URLSearchParams(window.location.search);
}
